import React from "react";
import { useRecoilState } from "recoil";
import { confirmStateAtom } from "../atoms/confirmAtom";
import { Button, Confirm } from "semantic-ui-react";

function GlobalConfirm() {
  const [confirmState, setConfirmState] = useRecoilState(confirmStateAtom);

  const handleCancel = () => {
    setConfirmState((prev) => ({ ...prev, isOpen: false }));
    confirmState.onCancel();
  };
  const handleConfirm = () => {
    setConfirmState((prev) => ({ ...prev, isOpen: false }));
    confirmState.onConfirm();
  };

  return (
    <Confirm
      open={confirmState.isOpen}
      header={confirmState.header}
      content={confirmState.content}
      cancelButton={
        <Button color="black">{confirmState.cancelButtonText || "Annuler"}</Button>
      }
      confirmButton={
        <Button color="green">{confirmState.confirmButtonText || "Confirmer"}</Button>
      }
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
}

export default GlobalConfirm;
